const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDataNew(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7.9374mm",
    height: "7.9374mm",
    viewBox: "0 0 7.9374 7.9374",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-88.594 -128.13)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-331.77 51.303)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 420.36,
    y: 76.828,
    width: 7.9374,
    height: 7.9374,
    rx: 0.93255,
    ry: 0.93255,
    style: {
      fillRule: "evenodd",
      fill: "#ffffff",
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.81085 0 0 .81085 70.582 15.435)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2003 0 0 1.2003 -87.514 -15.656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m436.81 77.048a2.694 2.694 0 012.4889 1.663 2.694 2.694 0 01-.58398 2.9359l-1.9049-1.9049z",
    style: {
      fillRule: "evenodd",
      fill: "#164d7c",
      paintOrder: "stroke markers fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m438.72 81.647a2.694 2.694 0 01-3.2519.42812 2.694 2.694 0 01-1.2552-3.0303 2.694 2.694 0 012.6022-1.9967v2.694z",
    style: {
      fillRule: "evenodd",
      fill: "#7fb536",
      paintOrder: "stroke markers fill"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m432.49 76.828v7.5625h7.5625",
    style: {
      fill: "none",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 0.75,
      stroke: "#4b8ec4"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDataNew);
export default __webpack_public_path__ + "static/media/icon_data_new.7f57c9de71b6f75bf0bc0017c8fbc6f4.svg";
export { ForwardRef as ReactComponent };